import event, {EVENTS} from '../lib/event';
import {clearCover} from './highlight.jsx';
import {getVm} from './vm';
import {getObjectValueByIndex} from './utils'

const blocksHasSubstack = [
    'control_repeat',
    'control_forever',
    'control_if',
    'control_if_else',
    'control_repeat_until'
];

const blocksDesc = {
    "event_whenflagclicked": {
        "name": "当小绿旗被点击",
        "desc": "当小绿棋被点击时，立即执行这块积木内的脚本。"
    },
    "event_whenkeypressed": {
        "name": "当按下[]键",
        "desc": "在键盘上按下指定键时，立即执行这块积木下的脚本积木。"
    },
    "event_whenthisspriteclicked": {
        "name": "当角色被点击",
        "desc": "当该角色被点击时，立即执行这块积木内的脚本。"
    },
    "event_whenbackdropswitchesto": {
        "name": "当背景切换到[]",
        "desc": "在作品使用了多个背景时，当切换到对应背景时执行这块积木内的脚本。"
    },
    "event_whengreaterthan": {
        "name": "当[]大于(n)",
        "desc": "当[响度/计时器]大于指定值时，立即执行这块积木内的脚本。"
    },
    "event_whenbroadcastreceived": {
        "name": "当接收到[?]",
        "desc": "当接收到指定消息，马上执行这块积木内的脚本。"
    },
    "event_broadcast": {
        "name": "广播[?]",
        "desc": "向所有角色及背景发送一个广播消息，通知收到该广播消息的角色开始执行对应脚本。"
    },
    "event_broadcastandwait": {
        "name": "广播[?]并等待",
        "desc": "发送完广播消息后，需要等待对应角色执行完脚本，才会运行下一个积木块。"
    },
    "motion_movesteps": {
        "name": "移动(n)步",
        "desc": "角色向右移动指定长度单位，相当于x坐标增加n。角色默认的运动方向为0度，即向右侧移动。"
    },
    "motion_turnright": {
        "name": "向右旋转(n)度",
        "desc": "素材本身及运动方向均向右旋转指定度数。"
    },
    "motion_turnleft": {
        "name": "向左旋转(n)度",
        "desc": "素材本身及运动方向均向左旋转指定度数。"
    },
    "motion_goto": {
        "name": "移到[]",
        "desc": "移动到某个位置。"
    },
    "motion_gotoxy": {
        "name": "移到(x,y)",
        "desc": "直接到达某一个坐标点。"
    },
    "motion_glideto": {
        "name": "在(n)秒内滑行到[]",
        "desc": "在指定时间内移动到某个坐标点。"
    },
    "motion_glidesecstoxy": {
        "name": "在(n)秒内滑行到(x,y)",
        "desc": "在指定时间内移动到某个坐标点。"
    },
    "motion_pointindirection": {
        "name": "面向(n)度方向",
        "desc": "设置素材本身及运动方向均面向指定的度数方向。"
    },
    "motion_pointtowards": {
        "name": "面向[]",
        "desc": "角色面向指定的另一个对象。"
    },
    "motion_changexby": {
        "name": "将x坐标增加(n)",
        "desc": "在原来的坐标基础上，增减素材的x坐标。其中正数为增加坐标值，负数为减少坐标值。"
    },
    "motion_changeyby": {
        "name": "将y坐标增加(n)",
        "desc": "在原来的坐标基础上，增减素材的y坐标。其中正数为增加坐标值，负数为减少坐标值。"
    },
    "motion_ifonedgebounce": {
        "name": "碰到边缘就反弹",
        "desc": "当角色碰到舞台边缘时，会朝反方向继续运动。"
    },
    "motion_setrotationstyle": {
        "name": "将旋转方式设为[]",
        "desc": "改变素材的旋转方式，但并不影响素材本身的角度。"
    },
    "motion_xposition": {
        "name": "x坐标",
        "desc": "x坐标轴"
    },
    "motion_yposition": {
        "name": "y坐标",
        "desc": "y坐标轴"
    },
    "motion_direction": {
        "name": "方向",
        "desc": "方向"
    },
    "looks_sayforsecs": {
        "name": "说[?](n)秒",
        "desc": "以角色对话方式持续显示输入的文本 ，持续时间为指定秒数。"
    },
    "looks_say": {
        "name": "说[?]",
        "desc": "以角色对话方式持续显示输入的文本 。"
    },
    "looks_thinkforsecs": {
        "name": "思考[?](n)秒",
        "desc": "显示输入的文本，并等待指定秒数。"
    },
    "looks_think": {
        "name": "思考[?]",
        "desc": "显示输入的文本"
    },
    "looks_switchcostumeto": {
        "name": "换成[?]造型",
        "desc": "切换造型到指定造型"
    },
    "looks_nextcostume": {
        "name": "下一个造型",
        "desc": "切换到下一个造型。"
    },
    "looks_switchbackdropto": {
        "name": "换成[?]背景",
        "desc": "切换背景到指定背景。"
    },
    "looks_nextbackdrop": {
        "name": "下一个背景",
        "desc": "切换到下一个背景。"
    },
    "looks_changesizeby": {
        "name": "将大小增加(n)",
        "desc": "在角色的原有[大小/宽度/高度]基础上增加输入数值%。"
    },
    "looks_setsizeto": {
        "name": "将大小设为(n)",
        "desc": "将角色的[大小/宽度/高度]设置为输入数值%。"
    },
    "looks_changeeffectby": {
        "name": "将[]增加特效(n)",
        "desc": "在原来的显示效果基础上，增减素材指定特效类型的特效值。其中正数为增加数值，负数表示减少数值。"
    },
    "looks_seteffectto": {
        "name": "[]特效设定为(n)",
        "desc": "设置素材的颜色、亮度等特殊显示效果。"
    },
    "looks_cleargraphiceffects": {
        "name": "清除图形特效",
        "desc": "清除素材的全部特殊显示效果。"
    },
    "looks_goforwardbackwardlayers": {
        "name": "前移(n)层",
        "desc": "将图层上移或输入数值的层数(例如1层)。"
    },
    "looks_costumenumbername": {
        "name": "造型[]",
        "desc": "获取该角色对应的造型编号或名称。"
    },
    "looks_backdropnumbername": {
        "name": "背景[]",
        "desc": "获取背景对应的编号或名称。"
    },
    "looks_size": {
        "name": "大小",
        "desc": "获取角色大小的值"
    },
    "sound_playuntildone": {
        "name": "播放声音[?]等待播完",
        "desc": "播放声音(此处为下拉选择，需要先在声音库中选择某个声音)，直到此声音全部播放完毕后，才执行这块积木之后的脚本。"
    },
    "sound_play": {
        "name": "播放声音[?]",
        "desc": "播放声音(此处为下拉选择，需要先在声音库中选择某个声音)，一开始播放，就执行这块积木之后的脚本。"
    },
    "sound_stopallsounds": {
        "name": "停止所有声音",
        "desc": "停止脚本中的的全部声音播放。"
    },
    "sound_changeeffectby": {
        "name": "将[]音效增加(n)",
        "desc": "增加或减少声音的音效(音调或者左右平衡)效果。拓展：音调中数值100为一个半音， 一个八度为12个半音。左右平衡数值范围需在 -100 到 100 之间。"
    },
    "sound_seteffectto": {
        "name": "将[]音效设为(n)",
        "desc": "设置声音的音效(音调或者左右平衡)效果的数值。拓展：音调中数值100为一个半音， 一个八度为12个半音。左右平衡数值范围需在 -100 到 100 之间。"
    },
    "sound_cleareffects": {
        "name": "清除音效",
        "desc": "清除声音的全部音效效果。"
    },
    "sound_changevolumeby": {
        "name": "将音量增加(n)",
        "desc": "增加或减少音乐的音量。若输入为正数则增加音量，输入为负数则减少音量，输入值为百分比。"
    },
    "sound_setvolumeto": {
        "name": "将音量设为(n)%",
        "desc": "设置音乐的音量大小，输入值为百分比。"
    },
    "sound_volume": {
        "name": "音量",
        "desc": "获取音量值"
    },
    "control_wait": {
        "name": "等待(n)秒",
        "desc": "等待输入的秒数(例如1秒)后，再执行这块积木之后的脚本。"
    },
    "control_repeat": {
        "name": "重复执行(n)次",
        "desc": "将这块积木内的脚本重复执行输入的次数(例如10次)。"
    },
    "control_forever": {
        "name": "重复执行",
        "desc": "将这块积木内的的脚本积木重复执行无限次。"
    },
    "control_if": {
        "name": "如果<>那么",
        "desc": "如果该条件成立，则执行这块积木内的脚本，否则不执行。"
    },
    "control_if_else": {
        "name": "如果<>那么,否则",
        "desc": "如果该条件成立，则执行那么积木块内的脚本，条件不成立则执行否则积木块内的脚本。"
    },
    "control_wait_until": {
        "name": "等待<>",
        "desc": "在该条件成立之前一直等待，直到条件成立后，运行这块积木之后的脚本。"
    },
    "control_repeat_until": {
        "name": "重复执行直到<>",
        "desc": "重复这块积木内的脚本，直到满足嵌入处的条件后，才运行此积木之后的脚本。"
    },
    "control_stop": {
        "name": "停止[]",
        "desc": "立即停止指定的脚本执行。"
    },
    "control_start_as_clone": {
        "name": "当作为克隆体启动时",
        "desc": "当被复制的对象启动时，执行下面脚本。"
    },
    "control_create_clone_of": {
        "name": "克隆[]",
        "desc": "复制一个当前对象，即克隆。"
    },
    "control_delete_this_clone": {
        "name": "删除此克隆体",
        "desc": "将当前的复制对象删除。"
    },
    "sensing_touchingobject": {
        "name": "碰到[]?",
        "desc": "布尔类型积木(返回值为成立或不成立)。侦测角色是否碰到另一个指定的素材。碰到就成立，否则不成立。"
    },
    "sensing_touchingcolor": {
        "name": "碰到颜色[]?",
        "desc": "布尔类型积木(返回值为成立或不成立)。侦测是否碰到指定颜色。"
    },
    "sensing_coloristouchingcolor": {
        "name": "颜色[]碰到[]？",
        "desc": "布尔类型积木(返回值为成立或不成立)。侦测某个颜色是否碰到指定颜色。"
    },
    "sensing_distanceto": {
        "name": "到[]的距离",
        "desc": "获得当前角色到鼠标指针的距离。"
    },
    "sensing_askandwait": {
        "name": "询问[?]并等待",
        "desc": "以角色对话方式显示输入的文本，并等待答复，收到答复后，再执行下面积木块。"
    },
    "sensing_answer": {
        "name": "回答",
        "desc": "获取回答的值。"
    },
    "sensing_keypressed": {
        "name": "按下[]键？",
        "desc": "布尔类型积木(返回值为成立或不成立)。侦测键盘上指定的键是否被按下。"
    },
    "sensing_mousedown": {
        "name": "按下鼠标?",
        "desc": "布尔类型积木(返回值为成立或不成立)。侦测鼠标是否被按下。"
    },
    "sensing_mousex": {
        "name": "鼠标的x坐标",
        "desc": "获得鼠标在舞台区的x坐标。"
    },
    "sensing_mousey": {
        "name": "鼠标的y坐标",
        "desc": "获得鼠标在舞台区的y坐标。"
    },
    "sensing_setdragmode": {
        "name": "将拖动模式设为[]",
        "desc": "设置当前对象可拖动或者不可拖动。"
    },
    "sensing_loudness": {
        "name": "响度",
        "desc": "侦测当前声音的音量数值大小。"
    },
    "sensing_timer": {
        "name": "计时器",
        "desc": "获得计时器数值。"
    },
    "sensing_resettimer": {
        "name": "计时器归零",
        "desc": "清空计时器的数值。"
    },
    "sensing_of": {
        "name": "[舞台]的[背景编号]",
        "desc": "获得舞台背景编号/背景名称/音量/我的变量。"
    },
    "sensing_current": {
        "name": "当前时间的[]",
        "desc": "获取当前的[年/月/日/星期/小时/分钟/秒]数据。"
    },
    "sensing_dayssince2000": {
        "name": "2000年至今的天数",
        "desc": "获取2000年至今天总共的天数。"
    },
    "sensing_username": {
        "name": "用户名",
        "desc": "获取用户名的值。"
    },
    "operator_add": {
        "name": "[]加[]",
        "desc": "用于计算数值A和数值B的和。"
    },
    "operator_subtract": {
        "name": "[]减[]",
        "desc": "用于计算数值A和数值B的差。"
    },
    "operator_multiply": {
        "name": "[]乘[]",
        "desc": "用于计算数值A和数值B的积。"
    },
    "operator_divide": {
        "name": "[]除[]",
        "desc": "用于计算数值A和数值B的商。"
    },
    "operator_random": {
        "name": "在[]和[]之间取随机数",
        "desc": "在输入的数值范围内随机选一个整数，例如在1和10间随机选一个整数，包括1和10。"
    },
    "operator_gt": {
        "name": "[]大于(n)？",
        "desc": "布尔类型积木(返回值为成立或不成立)。如果第一个数值大于第二个数值，返回值为成立，否则为不成立。"
    },
    "operator_lt": {
        "name": "[]小于(n)？",
        "desc": "布尔类型积木(返回值为成立或不成立)。如果第一个数值小于第二个数值，返回值为成立，否则为不成立。"
    },
    "operator_equals": {
        "name": "[]等于(n)？",
        "desc": "布尔类型积木(返回值为成立或不成立)。如果第一个数值等于第二个数值，返回值为成立，否则为不成立。"
    },
    "operator_and": {
        "name": "<>与<>",
        "desc": "布尔类型积木(返回值为成立或不成立)。< >并且< >：两个条件都成立时，则返回值为成立。"
    },
    "operator_or": {
        "name": "<>或<>",
        "desc": "布尔类型积木(返回值为成立或不成立)。<>或<>：两个条件中任意一个条件成立，则返回值为成立。"
    },
    "operator_not": {
        "name": "<>不成立",
        "desc": "布尔类型积木(返回值为成立或不成立)。当框内的条件不成立时，则返回值为成立。"
    },
    "operator_join": {
        "name": "连接[]和[]",
        "desc": "将两个输入的字符拼接在一起。例如“把[苹果][香蕉]连接在一起”的输出值为苹果香蕉。"
    },
    "operator_letter_of": {
        "name": "[]的第(n)个字符",
        "desc": "获得输入字符串中，从左往右的第指定个字符。"
    },
    "operator_length": {
        "name": "[]的字符数",
        "desc": "计算输入字符的长度。"
    },
    "operator_contains": {
        "name": "[]包含[]",
        "desc": "布尔类型积木(返回值为成立或不成立)。判断第一个输入的文本中是否包含第二个输入的文本内容。"
    },
    "operator_mod": {
        "name": "[]除以[]的余数",
        "desc": "计算第一个数除以第二个数的余数。"
    },
    "operator_round": {
        "name": "四舍五入(n)",
        "desc": "针对输入的数值进行四舍五入的取整运算。"
    },
    "operator_mathop": {
        "name": "[绝对值](n)",
        "desc": "将输入的数值进行指定的数学运算。"
    },
    "data_variable": {
        "name": "我的变量",
        "desc": "变量代表着可变的数值或者字符。全局变量能对所有角色发挥作用；角色变量仅在特定的角色中发挥作用。"
    },
    "data_setvariableto": {
        "name": "将[]设为[n]",
        "desc": "设置一个变量为输入的数值。"
    },
    "data_changevariableby": {
        "name": "将[]增加[n]",
        "desc": "将指定的变量在原来的数值基础上，增加或减少输入的数值。"
    },
    "data_showvariable": {
        "name": "显示变量[]",
        "desc": "在舞台中显示指定的变量。"
    },
    "data_hidevariable": {
        "name": "隐藏变量[]",
        "desc": "在舞台中隐藏指定的变量。"
    }
}
/**
 * 标准块的信息
 */
const blocksInfo = {
    'event_whenkeypressed': {
        type: 'event_whenkeypressed',
        fieldKeys: ['KEY_OPTIION']
    },
    'event_whenbackdropswitchesto': {
        type: 'event_whenbackdropswitchesto',
        fieldKeys: ['BACKDROP']
    },
    'event_whengreaterthan': {
        type: 'event_whengreaterthan',
        fieldKeys: ['WHENGREATERTHANMENU'],
        inputKeys: ['VALUE']
    },
    'event_whenbroadcastreceived': {
        type: 'event_whenbroadcastreceived',
        fieldKeys: ['BROADCAST_OPTION']
    },
    'event_broadcast': {
        type: 'event_broadcast',
        fieldKeys: ['BROADCAST_INPUT']
    },
    'event_broadcastandwait': {
        type: 'event_broadcastandwait',
        fieldKeys: ['BROADCAST_INPUT']
    },

    'control_wait': {
        type: "control_wait",
        inputKeys: ['DURATION']
    },
    'control_repeat': {
        type: "control_repeat",
        inputKeys: ['TIMES', 'SUBSTACK']
    },
    'control_forever': {
        type: "control_forever",
        dataId: 'forever',
        inputKeys: ['SUBSTACK']
    },
    'control_if': {
        type: 'control_if',
        inputKeys: ['CONDITION', 'SUBSTACK']
    },
    'control_if_else': {
        type: 'control_if_else',
        inputKeys: ['CONDITION', 'SUBSTACK', 'SUBSTACK2']
    },
    'control_wait_until': {
        type: 'control_wait_until',
        dataId: 'wait_until',
        inputKeys: ['CONDITION']
    },
    'control_repeat_until': {
        type: 'control_repeat_until',
        dataId: 'repeat_until',
        inputKeys: ['CONDITION', 'SUBSTACK']
    },
    'sensing_touchingobject': {
        type:'sensing_touchingobject',
        inputKeys: ["TOUCHINGOBJECTMENU"]
    },
    'sensing_touchingcolor': {
        type: 'sensing_touchingcolor',
        inputKeys: ['COLOR']
    },
    'sensing_coloristouchingcolor': {
        type: 'sensing_coloristouchingcolor',
        inputKeys: ['COLOR', 'COLOR2']
    },
    'sensing_distanceto': {
        type: 'sensing_distanceto',
        inputKeys: ['DISTANCETOMENU']
    },
    'sensing_askandwait': {
        type: 'sensing_askandwait',
        dataId: 'askandwait',
        inputKeys: ['QUESTION']
    },
    'sensing_answer': {
        type: 'sensing_answer',
        dataId: 'answer'
    },
    'sensing_keypressed': {
        type: 'sensing_keypressed',
        inputKeys: ['KEY_OPTION']
    },
    'sensing_setdragmode': {
        type: 'sensing_setdragmode',
        fieldKeys: ['DRAG_MODE'] //'draggable' 'not draggable'
    },
    "sensing_loudness": {
        type: "sensing_loudness",
        dataId: 'loudness'
    },
    "sensing_timer": {
        type: "sensing_timer",
        dataId: "timer"
    },
    "sensing_of": {
        type: 'sensing_of',
        dataId: 'of',
        fieldKeys: ['PROPERTY'],
        inputs: ['OBJECT']
    },
    'sensing_current': {
        type: 'sensing_current',
        dataId: 'current',
        fieldKeys: ['CURRENTMENU']
    },
    'operator_random': {
        type: 'operator_random',
        inputKeys: ['FROM', 'TO']
    },
    'operator_gt': {
        type: 'operator_gt',
        inputKeys: ['OPERAND1', 'OPERAND2']
    },
    'operator_lt': {
        type: 'operator_lt',
        inputKeys: ['OPERAND1', 'OPERAND2']
    },
    'operator_equals': {
        type: 'operator_equals',
        inputKeys: ['OPERAND1', 'OPERAND2']
    },
    'operator_and': {
        type: 'operator_and',
        inputKeys: ['OPERAND1', 'OPERAND2']
    },
    'operator_or': {
        type: 'operator_or',
        inputKeys: ['OPERAND1', 'OPERAND2']
    },
    'operator_not': {
        type: 'operator_not',
        inputKeys: ['OPERAND']
    },




}

/**
 * 获取当前 target 所有 blocks
 * @returns {Array} Array<{ id: string; parent?: string; }>
 */
const getAllBlocks = () => {
    const vm = getVm();
    if (vm.editingTarget) {
        const {editingTarget: {blocks: {_blocks}}} = vm;
        return Object.keys(_blocks).map(block => _blocks[block]);
    }
    return [];
};

const getBlockById = blockId => {
    if (!blockId) return null;
    blockId = stepsRuntime.getBlockId(blockId);
    const vm = getVm();
    if (vm && vm.editingTarget && vm.editingTarget.blocks) {
        return vm.editingTarget.blocks.getBlock(blockId);
    }
    return null;
};


/**
 * 获取到精确的块内部的输入位置的信息
 * @param quote
 * @returns {null|*}
 */
const getInputField = (quote) => {
    const parentBlock = getBlockById(stepsRuntime.getBlockId(quote.id));
    if (!parentBlock) return null;
    //首先尝试用名称找，但是很多时候名称是子块，已经发生变化
    if (quote.input) {
        if (parentBlock.inputs[quote.input]) {
            return parentBlock.inputs[quote.input];
        }
    }
    //再尝试用序号找
    if (quote.blockInputIndex != undefined) {
        return getObjectValueByIndex(parentBlock.inputs, quote.blockInputIndex);
    }else if (quote.inputIndex != undefined) { //兼容旧的脚本
        return getObjectValueByIndex(parentBlock.inputs, quote.inputIndex);
    }

    //field的情况
    if (quote.field) {
        if (parentBlock.fields[quote.field]) {
            return parentBlock.fields[quote.field];
        }
    }
    //再尝试用序号找
    if (quote.fieldIndex != undefined) {
        return getObjectValueByIndex(parentBlock.fields, quote.fieldIndex);
    }
    return null;
}

/**
 * 是否匹配块
 * @param quote
 * @param block
 */
const matchBlock = (quote, block) => {
    if (quote.opcode) { //从左侧toolbox中拖的情况
        if (quote.opcode != block.opcode) return false;
        if (quote.opcode === 'data_variable' && quote.varName != block.fields.VARIABLE.value) return false;
        if (quote.opcode === 'procedures_call' && quote.proccode != block.mutation.proccode) return false;
    }else if (quote.id) { //右侧代码编辑区
        if (stepsRuntime.getBlockId(quote.id) !== block.id) {
            return false;
        }
    }else {
        return false;
    }
    return true;
}

let timer;
let dragEvent;
event.on('workspaceChange', e => {
    if (e.type === 'endDrag') {
        dragEvent = e;
    }
    if (e.type === 'move') {
        if (timer) {
            clearTimeout(timer);
        }
        if (dragEvent) {
            timer = setTimeout(() => {
                // 每次一个块 endDrag 后，如果引发了其他块位置变动，
                // 则被影响的块会触发 move 事件，
                // 应该在所有的 move 事件完成后再获取当前 workspace 的状态
                // 所以这里封装了一个 endDragAndMove 事件
                //console.log('emit endDragAndMove');
                event.emit(EVENTS.END_DRAG_AND_MOVE, dragEvent);
                dragEvent = null;
            }, 100);
        }
    }
});

event.on(EVENTS.CLEAR_COVER, () => {
    clearCover();
});

window.getAllBlocks = getAllBlocks;
window.getBlockById = getBlockById;

export {
    blocksHasSubstack,
    getAllBlocks,
    getBlockById,
    blocksInfo,
    blocksDesc,
    getInputField,
    matchBlock,
};
